import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=ea84b966&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Help.vue"
export default component.exports